module.exports = __webpack_public_path__ + "img/workout-notebook_B095QCL6FF.9b19bc9d.jpg";